import type { EventAndSessions } from '@/api/Helpers'
import type { EventDetails } from '@/api/Helpers'
import { momentTo24hTime } from '@/helpers/TimeOfDay'
import type { Moment } from 'moment-timezone'

export interface AbstractInterval<T> {
  start: T
  end: T
}

export type MomentInterval = AbstractInterval<Moment>
export type StringInterval = AbstractInterval<string>

// eslint-disable-next-line no-unused-vars
export type EventDetailsPredicate<T extends EventDetails> = (event: T) => boolean

export function predicateForSessionStartsInInterval(window: StringInterval): EventDetailsPredicate<EventAndSessions> {
  const start = Number(window.start)
  const end = Number(window.end)

  function predicate(event) {
    const sessionStartTimes = event.sessions.map((session) => Number(momentTo24hTime(session.startMoment)))
    for (const time of sessionStartTimes) {
      // The end-time of the session does not matter.
      // TODO Consider supporting some padding, perhaps via metadata config.
      if (start <= time && time < end) {
        return true
      }
    }
    return false
  }

  return predicate
}
